export function defaultChecked(){
	return {
		sm: 2,
		p_st: 0
	};
};
export function defaultSliderValue(){
	return {
		area: '0;300',
		height: '0;10',
		price: '0;50000'
	};
};
export function defaultCheckedImage(){
	return {
		'imst': 0,
		'imrt': 0,
		'imna': 0,
		'imsi': 0,
		'imel': 0,
		'imwh': 0,
		'imrz': 0,
		'imja': 0,
		'imam': 0,
		'imeu': 0
	};
};



// WEBPACK FOOTER //
// ./src/vuex/default_values.js